import { fromPairs } from 'lodash-es'
import { State } from './state'

export const productsForEans = (state: State) => (eans: string[]) =>
  state.productsByEan &&
  fromPairs(eans.map((ean) => [ean, state.productsByEan![ean]]))
